import React from "react";

const Admin = () => {
	return (
		<div className="page-fit flex items-center justify-center">
			<div className="lg:w-[80%] flex md:flex-row flex-col items-center gap-4 sm:gap-8 justify-center sm:p-6 p-4">
				<div className="flex flex-col justify-center items-start h-full w-[70%] py-3 sm:ps-10">
					<h1 className="text-2xl sm:text-3xl font-semibold">
						Add Course
					</h1>
				</div>
				<form
					action=""
					className="flex flex-col justify-center items-start h-full w-[100%] sm:max-w-96 p-5 sm:p-8 bg-gray-200 shadow-xl mb-4 rounded-md"
				>
					<p className="opacity-70">Add Course Details</p>
					<h2 className="text-lg font-semibold mb-4">course..</h2>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">Course Name</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="text"
							name="name"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">
							Course Description
						</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="text"
							name="description"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">
							Course Image
						</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="url"
							name="image"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">
							Course Video
						</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="url"
							name="video"
						></input>
					</div>
					<div className="w-full mb-4 flex justify-between items-center">
						<p className="mb-2 text-base opacity-80">
							Course Premium
						</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-5 h-5"
							type="checkbox"
							name="premium"
						></input>
					</div>

					<button
						onClick={(e) => e.preventDefault()}
						className="text-lg text-white font-semibold rounded-md bg-orange-600 px-5 py-2 hover:bg-orange-800"
					>
						Submit
					</button>
				</form>
			</div>
		</div>
	);
};

export default Admin;
